module.exports = __webpack_public_path__ + "IbrahimSabeel-2d0d6b2e.webp";